/**
 * O nome da rodada sai do número, como nas abas da planilha do cliente:
 * "29-08", "29-08 1ª RODADA DE NEGOCIAÇÃO", "31-08 2ª RODADA DE NEGOCIAÇÃO".
 *
 * O comprador não dá nome a rodada. A descrição gravada no banco é ignorada
 * na tela de propósito: rodadas antigas foram criadas com nome livre, e assim
 * todas aparecem do mesmo jeito.
 */
export function nomeDaRodada(numero: number): string {
  return numero <= 1 ? 'Cotação inicial' : `${numero - 1}ª rodada de negociação`;
}
